import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';

const SEVERITY_MAP = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
};

/**
 * Shared status / auth / intake banner. Replaces page-local banner CSS.
 */
export function OnyxBanner({
  children,
  severity = 'info',
  className = '',
  onClose,
  'data-testid': dataTestId = 'onyx-banner',
}) {
  return (
    <Alert
      severity={SEVERITY_MAP[severity] || 'info'}
      onClose={onClose}
      className={['onyx-banner', className].filter(Boolean).join(' ')}
      data-testid={dataTestId}
      data-severity={severity}
    >
      {children}
    </Alert>
  );
}

OnyxBanner.propTypes = {
  children: PropTypes.node,
  severity: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  className: PropTypes.string,
  onClose: PropTypes.func,
  'data-testid': PropTypes.string,
};
